const defaultState = function () {
  return {
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    currentPage: 0,
    size: 10,
    sizeForDetail: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchConditions: {
      registerDate: {
        type: 'DateTime',
        title: '登録日時',
        property: '',
        display: false,
        value: ''
      },
      pointKbn: {
        type: 'MultiSelector',
        title: 'ポイント区分',
        property: '',
        display: false,
        value: '',
        options: [
          { code: 1, name: '付与' },
          { code: 2, name: '利用' }
        ]
      },
      userKbn: {
        type: 'MultiSelector',
        title: 'ユーザ区分',
        property: 'd_order_payment.method',
        display: false,
        value: '',
        options: [
          { code: 1, name: '付与' },
          { code: 2, name: '利用' }
        ]
      }
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getDefaultState: defaultState
}



// WEBPACK FOOTER //
// ./src/store/pages/point.js